// frontend/src/features/seo/components/SeoHeader.js
import React from 'react';
import Banner from '../../../ui/Banner';

export default function SeoHeader({
  activeTab,
  onTabChange,
  onOpenNewBrief,
  onOpenGovernance,
  onTriggerAudit,
}) {
  const tabs = [
    { id: 'topics', label: 'Topic & Keyword Map', icon: 'fas fa-compass' },
    { id: 'briefs', label: 'Content Briefs', icon: 'fas fa-file-alt' },
    {
      id: 'audit',
      label: 'On-Page & AIEO Assistant',
      icon: 'fas fa-robot',
    },
    {
      id: 'graph',
      label: 'Site Content Graph',
      icon: 'fas fa-project-diagram',
    },
    {
      id: 'refresh',
      label: 'Decay & Refresh Queue',
      icon: 'fas fa-clock-rotate-left',
    },
    {
      id: 'visibility',
      label: 'Visibility & Citations',
      icon: 'fas fa-chart-line',
    },
  ];

  return (
    <div className="seo-header-wrapper">
      <Banner
        title="SEO & AIEO Growth Studio"
        subtitle="Identify market search demand, create grounded content briefs, optimize for generative AI answer engines (Perplexity, ChatGPT, AI Overviews), and govern scaled publishing."
        type="page-header"
        actions={
          <div className="seo-header-actions">
            <button
              type="button"
              className="seo-btn seo-btn-secondary"
              onClick={onOpenGovernance}
              title="Configure programmatic publishing guardrails and CMS connection"
            >
              <i className="fas fa-shield-halved text-purple"></i>
              <span>Publishing Governance</span>
            </button>

            <button
              type="button"
              className="seo-btn seo-btn-secondary"
              onClick={onTriggerAudit}
              title="Inspect page or article for SEO & AIEO readiness"
            >
              <i className="fas fa-magnifying-glass-chart text-blue"></i>
              <span>Run Page Audit</span>
            </button>

            <button
              type="button"
              className="seo-btn seo-btn-primary"
              onClick={onOpenNewBrief}
              title="Create a new AI-assisted content brief"
            >
              <i className="fas fa-plus"></i>
              <span>Create Content Brief</span>
            </button>
          </div>
        }
      />

      {/* TABS TOOLBAR CARD */}
      <div className="seo-toolbar-card">
        <nav className="seo-tabs-bar" aria-label="SEO and AIEO Navigation">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                className={`seo-tab-btn ${isActive ? 'active' : ''}`}
                onClick={() => onTabChange(tab.id)}
              >
                <i className={tab.icon}></i>
                <span>{tab.label}</span>
                {tab.badge && <span className="seo-tab-badge">{tab.badge}</span>}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
